"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cleanup = function (number) {
    return ('' + number).replace(/\D/g, '');
};
var phoneNumber = function (phoneNumber) {
    var cleanedNumber = cleanup(phoneNumber);
    if (cleanedNumber.length !== 8)
        throw new Error('Phone number must be 8 digits');
    if (cleanedNumber[0] === '9' || cleanedNumber[0] === '4') {
        var match = cleanedNumber.match(/^(\d{3})(\d{2})(\d{3})$/);
        if (match) {
            var formatMobileNumber = match[1] + " " + match[2] + " " + match[3];
            return formatMobileNumber;
        }
    }
    else {
        var match = cleanedNumber.match(/^(\d{2})(\d{2})(\d{2})(\d{2})$/);
        if (match) {
            var formatLandlordNumber = match[1] + " " + match[2] + " " + match[3] + " " + match[4];
            return formatLandlordNumber;
        }
    }
    throw new Error('No matches for phone number');
};
var bankAccount = function (accountNumber) {
    var cleanedNumber = cleanup(accountNumber);
    if (cleanedNumber.length !== 11)
        throw new Error('Length of account number must be 11 digits');
    var match = cleanedNumber.match(/^(\d{4})(\d{2})(\d{5})$/);
    if (match) {
        var formatAccountNumber = match[1] + " " + match[2] + " " + match[3];
        return formatAccountNumber;
    }
    throw new Error('No matches for account number');
};
var socialSecNumber = function (socialSecurityNumber) {
    var cleanedNumber = cleanup(socialSecurityNumber);
    if (cleanedNumber.length !== 11)
        throw new Error('Length of social security number must be 11 digits');
    var match = cleanedNumber.match(/^(\d{6})(\d{5})$/);
    if (match) {
        var formatSocialSecNumber = match[1] + " " + match[2];
        return formatSocialSecNumber;
    }
    throw new Error('No matches for social security number');
};
var norFormatter = function (number, type) {
    switch (type) {
        case 'phone_number':
            return phoneNumber(String(number));
        case 'bank_account':
            return bankAccount(String(number));
        case 'social_sec_number':
            return socialSecNumber(String(number));
        default:
            throw new Error('must be phone_number, bank_account or social_sec_number');
    }
};
exports.default = norFormatter;
